package com.eladfinish.bible.contest.screens.search.usecases.date

import com.eladfinish.bible.contest.constants.StringConstants.DATE_SYMBOL

enum class DateQueryError(val message: String) {
    EMPTY("יש להקליד $DATE_SYMBOL ואחריו יום וחודש, $EXAMPLE"),
    MISSING_MONTH("חסר חודש. יש להקליד $DATE_SYMBOL ואחריו יום וחודש, $EXAMPLE"),
    DAY_OUT_OF_RANGE("היום בחודש צריך להיות בין 1 ל-30, $EXAMPLE"),
    MONTH_OUT_OF_RANGE("החודש צריך להיות בין 1 (ניסן) ל-12 (אדר), $EXAMPLE_ORDINAL"),
    AMBIGUOUS("התאריך לא ברור. יש להקליד $DATE_SYMBOL ואחריו יום וחודש אחד, $EXAMPLE"),
    NOT_A_DATE("לא זוהה תאריך. יש להקליד $DATE_SYMBOL ואחריו יום וחודש, $EXAMPLE"),
}

private const val EXAMPLE = "למשל: $DATE_SYMBOL 10 בתשרי"
private const val EXAMPLE_ORDINAL = "למשל: $DATE_SYMBOL 10 לחודש השביעי"

sealed interface ParseDateQueryResult {
    data class Success(val query: DateQuery) : ParseDateQueryResult
    data class Failure(val error: DateQueryError) : ParseDateQueryResult
}
